export const HEADING = 'Turn in your best paper'
export const SUBHEADING = 'We check your paper against billions of sources using technology similar to Turnitin'
